<template><div><h1>担心停止维护</h1>
<p>一个项目会停止维护主要原因是社区不活跃，用户量不够多，而且没有人愿意贡献。</p>
<p>VUX 和 Vue 一样正在发展中，越多越多的开发者在使用，在可预见的时间内不会突然停止维护。</p>
<p>希望大家能帮助完善文档，完善代码，帮助项目发展。</p>
<p>能贡献代码的贡献代码，<del>不能贡献代码直接用钱也可以 😃</del> 。</p>
</div></template><script>
export default {
  head: {"title":"担心停止维护 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// will-vux-stop-maintaining-56.vue?3f211c5e